import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import ShortcutLink from "@common/ShortcutLink";
import {UserContext} from "@context/UserContext";
import {BrandContext} from "@context/BrandContext";
import TrailNavigation from "../nav/TrailNavigation";
import useCurrentConcept from "@hooks/useCurrentConcept";
import axios from "@common/axios";

const StudentTasksWidget = props => {
    const {className} = props;
    const {user, setUser} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const [isLoading, setLoading] = useState(true);
    const [openStudentTrails, setOpenStudentTrails] = useState([]);

    const loadOpenStudentTrails = () => {
        axios.get('/web/ui/trail/openStudentTrails', {params: {pageNumber: 1}})
            .then(response => {
                setOpenStudentTrails(response.data);
                setLoading(false);
            });
    }

    useEffect(() => {
        if(user !== undefined && user.student) {
            loadOpenStudentTrails();
        } else {
            setLoading(false);
        }
    }, []);

    return (
        <DashboardWidget
            title={
                <div className="ch-dashboard-title-with-icon">
                    <svg className="ch-icon-medium" viewBox="0 0 128 128">
                        <use href="#pathways-icon"></use>
                    </svg>
                    <ShortcutLink className="ch-highlight" shortcutUrl={'/web/ui/view/trail/studentTrails'}> {/* NEW shortcut nav*/}
                    {/*<ShortcutLink className="ch-highlight" shortcutUrl={'/trail/viewStudentTrails.action'}>*/}
                        Active {brandConfig.tasksName}
                    </ShortcutLink>
                </div>
            }
            className={className}
            isLoading={isLoading}>
            <div className={'ch-dashboard-blk-body'}>
                {openStudentTrails.length > 0 && brandConfig.disableConcepts &&
                    <TrailNavigation grouping={false}/>
                }
                {openStudentTrails.length > 0 && !brandConfig.disableConcepts &&
                    <table style={{width: '100%'}} className={'ch-dashboard-list ch-list'}>
                        <tbody>
                            <tr>
                                <th>{brandConfig.taskName}</th>
                                <th>Assigned</th>
                            </tr>
                            {openStudentTrails.map((studentTrail, index) => (
                                <tr key={studentTrail.pathwayAssignmentId}>
                                    <td>
                                        <ShortcutLink className="ch-highlight" shortcutUrl={'/web/ui/view/trail/studentTrails'}>
                                            {studentTrail.pathwayAssignmentName}
                                        </ShortcutLink>
                                    </td>
                                    <td>{user.dateFormat.format(studentTrail.startDate)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                }
                {openStudentTrails.length == 0 &&
                    <div className="ch-list-item-disabled">No active {brandConfig.tasksName.toLowerCase()}</div>
                }
            </div>
        </DashboardWidget>
    )
}

export default StudentTasksWidget;